/**
 * Currency formatting with negative in front (e.g., -$123.45)
 */
export function formatCurrency (value) {
    const floatValue = Number(value);
    if (isNaN(floatValue)) return '$0.00'; // handle invalid input

    return floatValue
        .toFixed(2)                     // force 2 decimals
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",") // add commas
        .replace(/^(-?)(\d.*)/, "$1$$$2");     // prepend $
}

export function getNormalizedPercentageOfBillableCare (procBasedPay, normalizedBillableCare, financialNotes) {
    return(100 * (procBasedPay / (normalizedBillableCare + financialNotes )))
}
